module.exports = __webpack_public_path__ + "static/media/clients.a7f9d317.png";